import { PermissoesService } from './../../../service/usuario/permissoes.service';
import { ActivatedRoute } from '@angular/router';
import { PrecoProdutoClienteService } from './../../../service/produto/preco-produto-cliente.service';
import { ClienteService } from 'app/service/cliente/cliente.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ResponsePageable } from './../../../model/cliente/pageable/responsePageable.model';
import { ProdutoService } from './../../../service/produto/produto.service';
import { ClienteModel } from './../../../model/cliente/cliente.model';
import { PrecoService } from './../../../service/produto/preco.service';
import { PrecoModel } from 'app/model/produto/preco.model';
import { ProdutoModel } from './../../../model/produto/produto.model';
import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { PrecoProdutoClienteModel } from 'app/model/produto/preco-produto-cliente';
import * as CryptoJS from 'crypto-js';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

@Component({
  selector: 'app-precificacao',
  templateUrl: './precificacao.component.html',
  styleUrls: ['./precificacao.component.scss'],
})
export class PrecificacaoComponent implements OnInit {
  precoPadraoPorProduto = {} as PrecoModel;

  produto = {} as ProdutoModel;
  produtos: ProdutoModel[];

  cliente = {} as ClienteModel;
  clientes: ClienteModel[];

  precoModal = false;
  public pageProduto: ResponsePageable;

  produtoCliente = {} as ProdutoModel;
  produtosCliente: ProdutoModel[];

  precoCliente = {} as PrecoProdutoClienteModel;
  precoClientes: PrecoProdutoClienteModel[];

  precoAdicionado = {} as PrecoProdutoClienteModel;
  precoAdicionados: PrecoProdutoClienteModel[];

  precoPadraoAdd = {};

  public editPreco = false;
  public edit = false;
  public editShow = false;
  public selectedMovimentacao = false;
  public selectedTransporte = false;
  public submit = false;
  public addJust = false;
  public spinner = false;
  public edited = false;
  public editado = false;
  public errorAlert = false;
  public successDelete = false;
  public add = false;
  public editPrecoAdicionado = false;
  public precoForm: FormGroup;
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  @ViewChild('fecharModalProduto') fecharModalProduto;
  @ViewChild('closeModalPreco') closeModalPreco;
  @ViewChild('editarPreco') editarPreco;
  @ViewChild('fecharModalDetails') fecharModalDetails;
  @ViewChild('fechaPreco') fechaPreco;

  public arrayString: string;
  public creatorPrecificacao = false;
  public editorPrecificacao = false;
  public listaPrecificacao = false;
  public deletaPrecificacao = false;
  public superUser = false;

  @Input() clienteProp: ClienteModel;
  @Input() clientePropId: number;

  public clienteId: any;
  public deData: any;
  public idGrupo;
  public grupoProduto;
  public precoExcluir;
  public page: ResponsePageable;

  produtoDetail = {} as ProdutoModel;

  constructor(
    private clienteService: ClienteService,
    private precoService: PrecoService,
    private produtoService: ProdutoService,
    private fb: FormBuilder,
    private _snackBar: MatSnackBar,
    private precoProdutoClienteService: PrecoProdutoClienteService,
    private permissionService: PermissoesService,
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe(params => this.clienteId = params['id']);
    this.deData = CryptoJS.AES.decrypt(decodeURIComponent(this.clienteId), 'pcdoc');
    this.clienteId = JSON.parse(this.deData.toString(CryptoJS.enc.Utf8));
  }

  ngOnInit() {
    this.precoForm = this.fb.group({
      utilizacao: ['', Validators.required],
      armazenagem: ['', Validators.required],
      movImplantacao: ['', Validators.required],
      movEntrada: ['', Validators.required],
      movSaidaNormal: ['', Validators.required],
      movSaidaUrgente: ['', Validators.required],
      transImplantacao: ['', Validators.required],
      transEntrada: ['', Validators.required],
      transSaidaNormal: ['', Validators.required],
      transSaidaUrgente: ['', Validators.required],
      produtoServico: [ProdutoModel, Validators.required],
      cliente: [ClienteModel, Validators.required],
      selectedMovimentacao: [false],
      selectedTransporte: [false],
    });

    this.listPageProdutos(0, 10);
    this.listProdutosPorCliente(this.clienteId);
    this.getAuthority();
  }

  onSubmit() {
    this.submit = true;
  }

  showModal() {
    this.precoModal = true;
    this.precoPadraoPorProduto;
    this.fecharModalProduto.nativeElement.click();
  }

  changePage(event) {
    this.listPageProdutos(event.page, event.size);
  }

  getPrecoPadrao(id: number) {
    this.precoService.getPrecoPadraoPorProduto(id).subscribe((data) => {
      this.precoPadraoPorProduto = data;
      this.precoPadraoAdd = {
        utilizacao: data.precoUtilizacao,
        armazenagem: data.precoArmazenagem,
        movImplantacao: data.precoMovimentacaoImplantacao,
        movEntrada: data.precoMovimentacaoEntrada,
        movSaidaNormal: data.precoMovimentacaoSaidaNormal,
        movSaidaUrgente: data.precoTransporteSaidaUrgente,
        transImplantacao: data.precoTransporteImplantacao,
        transEntrada: data.precoTransporteEntrada,
        transSaidaNormal: data.precoTransporteSaidaNormal,
        transSaidaUrgente: data.precoTransporteSaidaUrgente,
        produtoServico: data.produtoServico,
        cliente: this.clienteProp
      };
    });
  }

  getPrecosAdicionados(idProduto: number, idCliente) {
    this.precoProdutoClienteService.listPrecoCliente(idProduto, idCliente).subscribe( data => {
      this.precoAdicionados = data;
      this.precoExcluir = data[0].id;
    }, error => {
      console.error(error);
    });
  }

  getDadosAddProduto2(cliente: ClienteModel, produto: ProdutoModel) {
    this.cliente = { ...cliente };
    this.produto = { ...produto };
  }

  detailProduto(produto: ProdutoModel) {
    this.produtoDetail = produto;
    this.idGrupo = produto.grupoProdutoServico.id;
    this.grupoProduto = produto.grupoProdutoServico.descricao;
    this.getPrecosAdicionados(produto.id, this.clienteId);
  }

  listPageProdutos(page, size) {
    this.produtoService.getPageProduto(page, size).subscribe((data) => {
      this.pageProduto = data;
      this.produtos = this.pageProduto.content;
      this.spinner = true;
    });
  }

  listProdutosPorCliente(id: number) {
    this.clienteService.getProdutosPorIdCliente(id).subscribe( data => {
      this.produtosCliente = data;
    }, error => {
      console.error(error);
    });
  }

  savePrecoAndProdutoPadrao(produto: ProdutoModel, idCliente: number, preco: PrecoProdutoClienteModel) {
    if (!this.editPrecoAdicionado) {
      this.adicionarProduto(produto, idCliente);
      this.savePrecoPadrao(preco);
    } else {
      this.editarPrecoAdicionado(preco);
    }
    this.closeModalPreco.nativeElement.click();
  }

  savePrecoAndProdutoPadrao2(produto: ProdutoModel, idCliente: number) {
    if (!this.editPrecoAdicionado) {
      this.adicionarProduto(produto, idCliente);
      this.savePreco();
    } else {
      this.editPrecoForm(produto);
    }
    this.submit = false;
    this.editShow = false;
  }

  postSubmit() {
    this.precoForm.reset();
    this.submit = false;
  }

  savePreco() {
    this.precoForm.get('produtoServico').setValue(this.produto);
    this.precoForm.get('cliente').setValue(this.clienteProp);
    this.precoProdutoClienteService.savePrecoProdutoCliente(this.precoForm.value).subscribe( data => {
      this.precoCliente = new PrecoProdutoClienteModel;
      this.addJust = true;
      this.postSubmit();
      this.openSnackBarSuccess('Preço atualizado com sucesso !');
    }, error => {
      console.error(error);
      this.openSnackBarError('Erro ao tentar atualizar o Preço !');
    });
  }

  editPrecoForm(produto: ProdutoModel) {
    this.precoForm.get('produtoServico').setValue(produto);
    this.precoForm.get('cliente').setValue(this.clienteProp);
    this.precoForm.addControl('id', new FormControl( this.precoExcluir));
    this.precoProdutoClienteService.editPrecoProdutoCliente(this.precoForm.value).subscribe( data => {
      this.openSnackBarSuccess('Preço atualizado com sucesso !');
      this.precoForm.reset();
      this.precoForm.removeControl('id');
    }, error => {
      console.error(error);
      this.openSnackBarError('Erro ao tentar atualizar o Preço !');
    });
  }

  savePrecoPadrao(preco: PrecoProdutoClienteModel) {
    this.precoForm.get('produtoServico').setValue(this.produto);
    this.precoProdutoClienteService.savePrecoProdutoCliente(preco).subscribe( data => {
      this.precoCliente = new PrecoProdutoClienteModel;
      this.addJust = true;
      this.postSubmit();
    }, error => {
      console.error(error);
    });
  }

  editarPrecoAdicionado(preco: PrecoProdutoClienteModel) {
    preco.id = this.precoExcluir;
    this.precoProdutoClienteService.editPrecoProdutoCliente(preco).subscribe( data => {
      this.openSnackBarSuccess('Preço atualizado com sucesso !');
    }, error => {
      console.error(error);
      this.openSnackBarError('Erro ao tentar atualizar o Preço !');
    });
  }

  getEditPrecoAdicionado(preco: PrecoProdutoClienteModel) {
    this.precoPadraoPorProduto = {
      aplicabilidades: [],
      cod: preco.code,
      dataAtual: preco.dataAtual,
      precoArmazenagem: preco.armazenagem,
      precoUtilizacao: preco.utilizacao,
      id: preco.id,
      precoMovimentacaoEntrada: preco.movEntrada,
      precoMovimentacaoImplantacao: preco.movImplantacao,
      precoMovimentacaoSaidaNormal: preco.movSaidaNormal,
      precoMovimentacaoSaidaUrgente: preco.movSaidaUrgente,
      precoTransporteEntrada: preco.transEntrada,
      precoTransporteImplantacao: preco.transImplantacao,
      precoTransporteSaidaNormal: preco.transSaidaNormal,
      precoTransporteSaidaUrgente: preco.transSaidaUrgente,
      precoPadrao: true,
      produtoServico: this.produtoDetail
    };
    this.precoModal = true;
    this.editPrecoAdicionado = true;
    this.editShow = true;
    this.selectedMovimentacao = true;
    this.selectedTransporte = true;
    this.fecharModalDetails.nativeElement.click();
  }

  adicionarProduto(produto: ProdutoModel, idCliente: number) {
    this.produtoService.adicionarProduto(produto, idCliente).subscribe(
      (data) => {
        this.listProdutosPorCliente(this.clientePropId);
        this.openSnackBarSuccess('Produto adicionado ao cliente com sucesso !');
        this.closeModalPreco.nativeElement.click();
      },
      (error) => {
        console.error(error);
        this.openSnackBarError('Erro ao tentar adicionar Produto ao cliente !');
      }
    );
  }

  adicionarProduto2(produto: ProdutoModel, idCliente: number) {
    this.produtoService.adicionarProduto(produto, idCliente).subscribe(
      (data) => {
        this.listProdutosPorCliente(this.clientePropId);
        this.openSnackBarSuccess('Produto adicionado ao cliente com sucesso !');
        this.closeModalPreco.nativeElement.click();
      },
      (error) => {
        console.error(error);
        this.openSnackBarError('Erro ao tentar adicionar Produto ao cliente !');
      }
    );
  }

  confirmeExclusao(produto: ProdutoModel, idCliente: number) {
    const confirme = confirm('Deseja excluir o produto deste cliente?');
    if (confirme === true) {
        this.apagarPreco(produto.id, this.clienteId);
        this.removerProduto(produto, idCliente);
    } else {
      console.log('Cancelou exclusão');
    }
  }

  removerProduto(produto: ProdutoModel, idCliente: number) {
    this.produtoService.removerProduto(produto, idCliente).subscribe( data => {
      const index = this.produtosCliente.indexOf(produto);
      if (index >= 0) {
        this.produtosCliente.splice(index, 1);
      }
      this.openSnackBarSuccess('Produto removido deste cliente com sucesso !');
    }, error => {
      console.error(error);
      this.openSnackBarError('Erro ao tentar remover Prdotuo do Cliente !');
    });
  }

  apagarPreco(idProduto: number, idCliente: number) {
    this.precoProdutoClienteService.deletePrecoProdutoCliente(idProduto, idCliente).subscribe( data => {
    }, error => {
      console.error(error);
    });
  }

  getDadosEditPreco(preco: PrecoModel) {
    this.precoPadraoPorProduto = { ...preco };
    this.editPreco = true;
    this.edit = true;
    this.editShow = true;
    this.selectedMovimentacao = true;
    this.selectedTransporte = true;
  }

  getAuthority() {
    this.getItemAuthority('authority');
    if (this.arrayString.includes('ADD_EMPRESA')) {
      this.creatorPrecificacao = true;
    }
    if (this.arrayString.includes('EDIT_EMPRESA')) {
      this.editorPrecificacao = true;
    }
    if (this.arrayString.includes('LIST_EMPRESA')) {
      this.listaPrecificacao = true;
    }
    if (this.arrayString.includes('DELETE_EMPRESA')) {
      this.deletaPrecificacao = true;
    }
    if (this.arrayString.includes('SUPER_USER')) {
      this.superUser = true;
    }
  }

  getItemAuthority(key) {
    const store = sessionStorage.getItem(key);
    if (store) {
      try {
        const bytes = CryptoJS.AES.decrypt(
          store,
          sessionStorage.getItem('ticket-ECM')
        );
        this.arrayString = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return this.arrayString;
      } catch (e) {
        sessionStorage.clear();
      }
    }

    return null;
  }

  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, '', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ['success-snackbar']
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message,'', {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ['error-snackbar']
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/produto-components/precificacao/precificacao.component.ts